import { cdnImageUrl } from 'helpers/image'
import React, { FC } from 'react'
import Brand from 'store/entities/Brands/Brand.store'
import BrandLogoChip from 'uiComponents/atoms/Chip/BrandLogoChip'

interface Props {
  brand: Brand
  className?: string
  active?: boolean
  onClick: () => void
}

const BrandFilterButton: FC<Props> = ({
  className,
  brand,
  onClick,
  active,
}) => {
  const brandLogoSrc = cdnImageUrl(brand.logoImageHash!, {
    trim: 1,
    height: 100,
    width: 300,
  })

  return (
    <BrandLogoChip
      loading="lazy"
      className={className}
      logoSrc={brandLogoSrc}
      onClick={onClick}
      active={active}
      fallBackText={brand.name}
      hideBrandName
    />
  )
}

export default BrandFilterButton
